import React from 'react';
import { CancelDocument as CancelDocumentIcon } from '@dxb-web-ui-framework/design-system/dist/icons';
import { MenuMoreItemProps } from '@dxb-web-ui-framework/design-system/dist/components/organisms/menuMore/MenuMore';
import { GetApp as DownloadDetailsIcon } from '@dxb-web-ui-framework/design-system/dist/icons';
import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';

const payrollMenuMoreItemsActions: (data: any, callback: Function, t: Function) => MenuMoreItemProps[] = (
  data,
  callback,
  t: Function,
) => [
  {
    label: t(
      'payrollPage.PayrollTable.UsePayrollGridConfig.GetAllowedPayrollItemsActions.payrollMenuMoreItemsActions.Cancel.Label',
    ),
    icon: <CancelDocumentIcon />,
    // TODO: add transfer action types when context is created
    onClick: () => callback(data, 'CANCEL'),
    disabled: data.status === 'Executed',
  },
  {
    label: t(
      'payrollPage.PayrollTable.UsePayrollGridConfig.GetAllowedPayrollItemsActions.payrollMenuMoreItemsActions.Download.Label',
    ),
    // TODO: add transfer action types when context is created
    onClick: () => callback(data, 'DOWNLOAD'),
    disabled: false,
    icon: <DownloadDetailsIcon />,
  },
];

const getAllowedPayrollItemsActions = (
  cb: Function,
  rowData: any,
  t: Function,
  requiredEntitlements?: string[],
  requiredEntitlementsLogic?: string,
): MenuMoreItemProps[] => {
  const isAllowedForAllActions = isEmpty(requiredEntitlements) && !requiredEntitlementsLogic;

  if (isAllowedForAllActions) {
    return payrollMenuMoreItemsActions(rowData, cb, t);
  }

  return payrollMenuMoreItemsActions(rowData, cb, t);
};

export { payrollMenuMoreItemsActions, getAllowedPayrollItemsActions };
